import { SentimentVeryDissatisfied } from '@mui/icons-material';
import {
  Card,
  CardHeader,
  Divider,
  useMediaQuery,
  Box,
  Typography,
  Button,
  Tooltip,
} from '@mui/material';
import type { Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PropertyList } from '../../../../../components/atoms/property-list';
import { PropertyListItem } from '../../../../../components/atoms/property-list-item';
import { Host } from '../../../api/types/host';

import { Can } from '@/permissions/can';

interface Props {
  host: Host;
  handleOpenGroupDialog: () => void;
}

export const DestinationGroupInfo = ({ host, handleOpenGroupDialog }: Props) => {
  const { t } = useTranslation(['host', 'common']);

  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const align = mdDown ? 'vertical' : 'horizontal';

  return (
    <Card variant="outlined">
      <CardHeader
        title={t('host:destinationGroup.cardTitle')}
        action={
          <Can I="manageDestinationGroup" a="Hosts" passThrough>
            {allowed => (
              <Tooltip
                title={t('common:notSufficientPermissions')}
                disableHoverListener={allowed}
                disableFocusListener={allowed}>
                <span>
                  <Button
                    sx={{ ml: 2 }}
                    disabled={!host.allowInviteToParking || !allowed}
                    onClick={handleOpenGroupDialog}>
                    {t('host:destinationGroup.setGroup')}
                  </Button>
                </span>
              </Tooltip>
            )}
          </Can>
        }
      />
      <Divider />
      {host.destinationGroup ? (
        <PropertyList>
          <PropertyListItem
            align={align}
            label={`${t('host:destinationGroup.name')}`}
            value={host.destinationGroup.name}
          />
        </PropertyList>
      ) : (
        <Box sx={{ p: 3, display: 'flex', alignItems: 'center' }}>
          <Typography color="primary.main" variant="body2">
            {t('host:destinationGroup.noGroup')}
          </Typography>
          <SentimentVeryDissatisfied sx={{ color: 'primary.main' }} />
        </Box>
      )}
    </Card>
  );
};
